import React, { useRef } from "react";
import axios from "../../../../../config/axios";
import { Button, Modal, Spinner } from "react-bootstrap";
import { Form, Formik } from "formik";
import FormInputText from "../../../../../components/Forms/FormInputText";
import * as Yup from "yup";
import { dateFormatter } from "../../../../../global";
import moment from "moment";

const BookingCheckoutDialog = ({ stay, handleClose, handleSubmit }) => {
  function submit(data, { setSubmitting, setErrors }) {
    setSubmitting(true);
    axios
      .post(
        `/api/v1/stays/${stay.id}/manual_checkout.json?checkout_confirmed_at=${data.checkout_confirmed_at}`
      )
      .then(function (response) {
        handleSubmit(response.data);
      })
      .catch(function (error) {
        console.log(error.response.data);
        setErrors(error.response.data);
        setSubmitting(false);
      });
  }

  const formRef = useRef();

  const minCheckinDate = stay
    ? moment(stay.initial_checkin_at || stay.from).startOf("day")
    : null;
  const maxCheckoutDate = stay ? moment(stay.to).endOf("day") : null;
  const defaultCheckoutDate = () => {
    const today = moment();

    if (today.isAfter(moment(stay.to), "day")) {
      return moment(stay.to).format(moment.HTML5_FMT.DATETIME_LOCAL);
    }

    return today.format(moment.HTML5_FMT.DATETIME_LOCAL);
  };

  return (
    <>
      <Modal show={true} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Checkout</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!stay ? (
            <div className={"d-flex justify-content-center"}>
              <Spinner
                className={"text-center"}
                animation="border"
                variant="primary"
              />
            </div>
          ) : (
            <>
              <Formik
                innerRef={formRef}
                initialValues={{
                  ...stay,
                  checkout_confirmed_at: defaultCheckoutDate(),
                }}
                validationSchema={() => {
                  return Yup.object({
                    checkout_confirmed_at: Yup.date()
                      .min(
                        minCheckinDate.toDate(),
                        `muss größer als das Checkin Datum ${dateFormatter(
                          minCheckinDate
                        )} sein`
                      )
                      .max(
                        maxCheckoutDate.toDate(),
                        `muss kleiner als das Checkout Datum ${dateFormatter(
                          stay.to
                        )} sein`
                      ),
                  });
                }}
                onSubmit={submit}
              >
                {() => (
                  <Form>
                    <FormInputText
                      name="checkout_confirmed_at"
                      label="Checkout"
                      type="datetime-local"
                      min={minCheckinDate.format(
                        moment.HTML5_FMT.DATETIME_LOCAL
                      )}
                      max={maxCheckoutDate.format(
                        moment.HTML5_FMT.DATETIME_LOCAL
                      )}
                    />
                  </Form>
                )}
              </Formik>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Schließen
          </Button>
          <Button onClick={() => formRef?.current?.handleSubmit()}>
            Speichern
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BookingCheckoutDialog;
